import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

export const isPosthogEnabled = !!(KEY && KEY.length > 0);

let initialized = false;
export function initPosthog() {
  if (!isPosthogEnabled || initialized || typeof window === "undefined") return;
  posthog.init(KEY, {
    api_host: HOST,
    autocapture: true,
    capture_pageview: "history_change",
    capture_pageleave: true,
    persistence: "localStorage+cookie",
  });
  initialized = true;
}

export function track(event, properties) {
  if (!isPosthogEnabled || !initialized) return;
  try {
    posthog.capture(event, properties || {});
  } catch (e) {
    // Non-blocking analytics — log but never surface to user
    if (typeof console !== "undefined") console.warn("posthog capture failed:", e?.message);
  }
}

export function identify(id, properties) {
  if (!isPosthogEnabled || !initialized) return;
  try {
    posthog.identify(id, properties || {});
  } catch (e) {
    if (typeof console !== "undefined") console.warn("posthog identify failed:", e?.message);
  }
}

export default posthog;
